export default __webpack_public_path__ + "static/media/hw.1b51edaf.png";